(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-lifestyle-media]').forEach(media => {
      if (media.dataset.initialized) return;
      media.dataset.initialized = 'true';
      const video = media.querySelector('video');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      video.muted = true;
      video.controls = false;
      const synchronize = () => {
        const automatic = !reducedMotion.matches && !navigator.connection?.saveData;
        if (visible && !document.hidden && automatic) {
          // Leave the poster visible if the browser blocks automatic playback.
          video.play().catch(() => {});
        } else video.pause();
      };
      const onMotionChange = synchronize;
      reducedMotion.addEventListener('change', onMotionChange);
      document.addEventListener('visibilitychange', synchronize);
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
        synchronize();
      }, { threshold: [0, 0.25] });
      observer.observe(media);
      const onUnload = event => {
        if (!event.target.contains(media)) return;
        video.pause();
        observer.disconnect();
        reducedMotion.removeEventListener('change', onMotionChange);
        document.removeEventListener('visibilitychange', synchronize);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    });
  }
  initialize();
  if (!window.jmtLifestyleListener) {
    window.jmtLifestyleListener = true;
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  }
})();
